import { useTenantStore } from 'src/stores/tenant';
import {
  getTenancyModeDisplayName,
  getTenancyModeDescription,
  getTenancyModeConfig,
} from 'src/utils/tenancyMode';

/**
 * Hook for accessing tenancy mode functionality
 */
export const useTenancyMode = () => {
  const {
    tenancyMode,
    availableTenants,
    actions: {
      canCreateTenant,
      isSingleTenantMode,
      isMultiTenantMode,
      setTenancyMode,
    },
  } = useTenantStore();

  const config = getTenancyModeConfig();

  return {
    // Current mode
    tenancyMode,

    // Mode checks
    isSingleTenantMode: isSingleTenantMode(),
    isMultiTenantMode: isMultiTenantMode(),

    // Capabilities
    canCreateTenant: canCreateTenant(),
    canSwitchTenants:
      config.allowTenantSwitching && availableTenants.length > 1,
    maxTenants: config.maxTenants,

    // Display information
    displayName: getTenancyModeDisplayName(tenancyMode),
    description: getTenancyModeDescription(tenancyMode),

    // Actions
    setTenancyMode,

    // Configuration
    config,
  };
};
